import { INavLink } from "core-integration/src/hooks/types";
import { useLanguageFromPath } from "plos/src/hooks/useLanguageFromPath";
import { localizePath } from "plos/src/utils/language";
import { forwardRef } from "react";
import { NavLink } from "react-router";
import { activeLinkStyles, navItemStyles, navLinkStyles } from "./NavItem.css";

type NavItemProps = INavLink & {
  onClick?: () => void;
};

const NavItem = forwardRef<HTMLLIElement, NavItemProps>(
  ({ text, href, rel, useRouter, onClick }, ref) => {
    const lang = useLanguageFromPath();
    const localizedHref = useRouter ? localizePath(href, lang) : href;

    return (
      <li className={navItemStyles} ref={ref}>
        {useRouter ? (
          <NavLink
            className={({ isActive }) =>
              `${navLinkStyles} ${isActive ? activeLinkStyles : ""}`
            }
            end={href === "/" || localizedHref === `/${lang}`}
            onClick={onClick}
            to={localizedHref}
          >
            {text}
          </NavLink>
        ) : (
          <a
            className={navLinkStyles}
            href={href}
            onClick={onClick}
            target="_blank"
            rel={rel}
          >
            {text}
          </a>
        )}
      </li>
    );
  },
);

export default NavItem;
